import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requireOfficeAccess } from '@/features/auth/utils/require-office-access';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { FIELD_OPS_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { LeaveReportPage } from '@/features/leaveReport/pages/LeaveReportPage';
import { leaveReportSearchSchema } from '@/features/leaveReport/types/leaveReport.types';

export const Route = createFileRoute('/_auth/hr-form/leave-report')({
  beforeLoad: () => {
    requireOfficeAccess();
    requirePermission(FIELD_OPS_PERMISSIONS.LEAVE_VIEW);
  },
  validateSearch: leaveReportSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Leave Report">
      <Suspense fallback={<PageLoader />}>
        <LeaveReportPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
